import React, { useState, useEffect, useRef } from 'react';

const AnimatedNumber = ({ value, format = (v) => v, className = '' }) => {
  const [displayValue, setDisplayValue] = useState(value);
  const [color, setColor] = useState('text-black');
  const prevValueRef = useRef(value);

  useEffect(() => {
    if (value !== prevValueRef.current) {
      // Xác định màu dựa trên sự thay đổi
      const newColor = value > prevValueRef.current ? 'text-green-500' : 'text-red-500';
      setColor(newColor);
      setDisplayValue(value);

      // Reset màu về đen sau 2 giây
      const timer = setTimeout(() => {
        setColor('text-black');
      }, 2000);

      prevValueRef.current = value;

      return () => clearTimeout(timer);
    }
  }, [value]);

  return (
    <span className={`transition-colors duration-500 ${color} ${className}`}>
      {format(displayValue)}
    </span>
  );
};

export default AnimatedNumber; 